import React from "react";
import { useIntl } from "react-intl";
import { LoadingSpinnerWembii } from "../component/LoadingSpinnerWembii";
import WaitingGameOffer from "../component/games/WaitingGameOffer";
import "./CheckingConnection.scss";

export const CheckingConnection = () => {
  const intl = useIntl();

  return (
    <div className="checking-connection-page">
      <div className="checking-connection-page__ambient" aria-hidden />
      <div className="checking-connection-page__shell">
        <LoadingSpinnerWembii active size="lg" />
        <h1 className="checking-connection-page__title">Comprobando conexión</h1>
        <p className="checking-connection-page__text">
          Esto puede tardar un momento; por favor espera…
        </p>
      </div>

      <WaitingGameOffer
        isWaiting
        promptTitle={intl.formatMessage({
          id: "app.connection.dinoPromptTitle",
        })}
        promptLead={intl.formatMessage({
          id: "app.connection.dinoPromptLead",
        })}
        promptQuestion={intl.formatMessage({
          id: "app.connection.dinoPromptQuestion",
        })}
        gameNote={intl.formatMessage({ id: "app.connection.dinoGameNote" })}
        closeButtonLabel={intl.formatMessage({
          id: "app.connection.dinoCloseGame",
        })}
      />
    </div>
  );
};
